import React from 'react'
import * as Displays from 'support/displays'
import {
  Collection,
  CollectionEntryWhere,
  ForEachModel, ModelProxy,
  ReadOnlyCollection,
  SortBy,
  useValue,
  ValueToCollection, WhenModel,
  WhenModelValue
} from '@morningtrain/react-resources'
import Slot from './Slot'
import moment from 'moment'
import MountSmartviewOnClick from 'support/utilities/MountSmartviewOnClick'
import CreateShiftSmartview from 'widgets/smartviews/shifts/CreateShiftSmartview'
import { AddActionButton } from 'ui/buttons'
import ShiftHeader from 'ui/schedule/ShiftHeader'
import Weather from 'ui/schedule/Weather'
import ScheduleNotifications from 'widgets/shifts/themes/calendar/ScheduleNotifications'
import { Translation } from '@morningtrain/react-translations'
import ScheduleDayProgressBar from 'widgets/shifts/themes/calendar/ScheduleDayProgressBar'
import { StaticFilter } from '@morningtrain/react-filters'

export default function CalendarDayContent ({
  scheduleId,
  weekDay = null,
  mode = 'view'
}) {
  const rawWeekday = useValue('key')

  const isFuture = date => !!date && moment(date).diff(moment()) > 0
  const isToday = date => !!date && moment(date).isSame(moment(), 'day') > 0
  const canCreate = date => (isFuture(date) || isToday(date)) && mode === 'plan'

  return (
    <>
      <ShiftHeader
        date={(
          <>
            <ScheduleNotifications date={rawWeekday} scheduleId={scheduleId} />
            <Displays.Date
              name='key'
              dateFormat='ll'
            />
          </>
        )}
        title={<Displays.Date name='key' dateFormat='dddd' />}
        weather={<Weather date={rawWeekday} />}
        progressBar={
          mode === 'plan'
            ? (
              <Collection resourceName='shifts.schedule' operationName='day_summary' operationContext={{ scheduleId: scheduleId }}>
                <StaticFilter name='schedule' value={scheduleId} />
                <CollectionEntryWhere path='weekDay' matches={weekDay}>
                  <ScheduleDayProgressBar date={rawWeekday} scheduleId={scheduleId} />
                </CollectionEntryWhere>
              </Collection>
              )
            : null
        }
      />
      <ValueToCollection name='collection'>
        <ForEachModel>
          <ModelProxy>
            <WhenModel>
              <Slot mode={mode} />
            </WhenModel>
          </ModelProxy>
        </ForEachModel>
      </ValueToCollection>

      <WhenModelValue name='key' condition={canCreate}>
        <MountSmartviewOnClick
          smartview={<CreateShiftSmartview weekDay={weekDay} scheduleId={scheduleId} date={rawWeekday} />}
          replace={false}
        >
          <AddActionButton>
            <Translation name='actions.add_shift' />
          </AddActionButton>
        </MountSmartviewOnClick>
      </WhenModelValue>
    </>
  )
}
